<app-main-primeng-table [id]="'cmxa-product-history-table'"
                        [dataKey]="'id'"
                        [scrollable]="true"
                        [scrollHeight]="'auto'"
                        [tableType]="TABLE_TYPE.HISTORY"
                        [rowData]="productHistory$ | async">
</app-main-primeng-table>
